






































import Vue from 'vue';

export default Vue.extend({
  components: {},
  props: {
    data: {
      type: Object,
      default: null,
    },
    props: {
      type: Object,
      default: () => ({
        country: 'LT',
      }),
    },
  },
  data() {
    return {
      search: '',
      suggestions: [] as any,
      loading: false,
      debouncedPredictions: null as any,
    };
  },
  mounted() {
    const debounce = () => {
      const wait = 750;
      let timer: any;
      return () => {
        if (timer) {
          clearTimeout(timer); // clear any pre-existing timer
        }
        timer = setTimeout(async () => {
          const google = (window as any).google;
          const autocomplete = new google.maps.places.AutocompleteService();
          const predictions = await autocomplete.getPlacePredictions({
            input: this.search,
            types: ['geocode'],
            componentRestrictions: {
              country: this.props.country.toLowerCase(),
            },
          });
          this.suggestions = predictions?.predictions || [];
          this.loading = false;
        }, wait);
      };
    };
    (this.$refs.searchInput as any).focus();
    this.debouncedPredictions = debounce();
  },
  methods: {
    focusSearch() {
      (this.$refs.searchInput as any).focus();
    },
    // eslint-disable-next-line camelcase
    selectPlace(item: { place_id: any; location: any; description: any }) {
      const google = (window as any).google;
      const service = new google.maps.places.PlacesService(this.$refs.map);
      service.getDetails(
        { placeId: item.place_id },
        (place: { geometry: { location: any } }) => {
          item.location = place?.geometry.location;
          this.$emit('save', {
            key: 'clientAddress',
            focusNext: true,
            value: {
              ...item,
              location: place?.geometry.location,
              textValue: item.description,
            },
          });
        }
      );
    },
    loadSuggestions() {
      if (this.search.length < 3) {
        return;
      }
      this.loading = true;
      this.debouncedPredictions();
    },
  },
});
